import AlertCard from './AlertCard';

export default AlertCard;
